<template>
  <div
    class="vertical-layout h-100"
    :class="[layoutClasses]"
    :data-col="isNavMenuHidden ? '1-column' : null"
  >
    <!-- Navbar -->
    <b-navbar
      :toggleable="false"
      variant=""
      class="header-navbar navbar navbar-shadow align-items-center fixed-top"
    >
      <slot
        name="navbar"
        :toggleVerticalMenuActive="toggleVerticalMenuActive"
        navbarBackgroundColor=""
        :navbarTypeClass="[
          'fixed-top header-navbar navbar navbar-shadow align-items-center',
        ]"
      >
        <app-navbar-vertical-layout
          :key="$route.fullPath"
          :is-nav-menu-hidden="isNavMenuHidden"
          :toggle-vertical-menu-active="toggleVerticalMenuActive"
        />
      </slot>
    </b-navbar>
    <!--/ Navbar -->

    <!-- Vertical Nav Menu -->
    <vertical-nav-menu
      v-if="!isNavMenuHidden"
      :is-vertical-menu-active="isVerticalMenuActive"
      :toggle-vertical-menu-active="toggleVerticalMenuActive"
    >
      <template #header="slotProps">
        <slot
          name="vertical-menu-header"
          v-bind="slotProps"
        />
      </template>
    </vertical-nav-menu>
    <!-- /Vertical Nav Menu -->

    <!-- Vertical Nav Menu Overlay -->
    <div
      class="sidenav-overlay"
      :class="overlayClasses"
      @click="isVerticalMenuActive = false"
    />
    <!-- /Vertical Nav Menu Overlay -->

    <!-- Content -->

    <!-- CONTENT TYPE: Left -->
    <transition
      :name="routerTransition"
      mode="out-in"
    >
      <component :is="layoutContentRenderer">
        <template
          v-for="(index, name) in $scopedSlots"
          v-slot:[name]="data"
        >
          <slot
            :name="name"
            v-bind="data"
          />
        </template>
      </component>
    </transition>
    <!--/ Content -->

    <slot name="customizer" />
    <upload-progress v-if="filesUploading && showUploadProgress" />
  </div>
</template>

<script>
import { onUnmounted } from '@vue/composition-api'
import AppNavbarVerticalLayout from '@core/layouts/components/app-navbar/AppNavbarVerticalLayout.vue'
import useAppConfig from '@core/app-config/useAppConfig'
import { BNavbar } from 'bootstrap-vue'
import LayoutContentRendererDefault from '@core/layouts/components/layout-content-renderer/LayoutContentRendererDefault.vue'
import VerticalNavMenu from './components/vertical-nav-menu/VerticalNavMenu.vue'
import UploadProgress from '@/components/info/UploadFilesProgress.vue'
import useVerticalLayout from './useVerticalLayout'
import mixinVerticalLayout from './mixinVerticalLayout'

export default {
  components: {
    AppNavbarVerticalLayout,
    VerticalNavMenu,
    BNavbar,
    LayoutContentRendererDefault,
    UploadProgress,
  },
  mixins: [mixinVerticalLayout],
  computed: {
    layoutContentRenderer() {
      return 'layout-content-renderer-default'
    },
    showUploadProgress() {
      return (
        this.$route.name !== 'object-files'
        || this.$store.state.multiparts.showMultiparts
        || this.differentBucketNames
        || this.differentUploadPaths
      )
    },
    bucketName() {
      return this.$store.state.uploading.bucketName
    },
    currentUploadPath() {
      return this.$store.state.uploading.currentUploadPath
    },
    differentBucketNames() {
      return (
        this.$store.state.uploading.requestFiles.filter(
          e => e.data.bucketName !== this.bucketName,
        ).length > 0
      )
    },
    differentUploadPaths() {
      return (
        this.$store.state.uploading.requestFiles.filter(
          e => e.data.uploadPath !== this.currentUploadPath,
        ).length > 0
      )
    },
  },
  setup() {
    const {
      routerTransition,
      navbarType,
      footerType,
      isNavMenuHidden,
    } = useAppConfig()

    const {
      isVerticalMenuActive,
      toggleVerticalMenuActive,
      isVerticalMenuCollapsed,
      layoutClasses,
      overlayClasses,
      resizeHandler,
      filesUploading,
    } = useVerticalLayout(navbarType, footerType)

    window.addEventListener('beforeunload', e => {
      if (filesUploading.value) {
        e.preventDefault()
        const confirmationMessage = '\\o/';
        (e || window.event).returnValue = confirmationMessage // Gecko + IE
        return confirmationMessage
      }
      return null
    })

    // Resize handler
    resizeHandler()
    window.addEventListener('resize', resizeHandler)
    onUnmounted(() => {
      window.removeEventListener('resize', resizeHandler)
    })

    return {
      isVerticalMenuActive,
      toggleVerticalMenuActive,
      isVerticalMenuCollapsed,
      overlayClasses,
      layoutClasses,
      filesUploading,

      // App Config
      routerTransition,
      isNavMenuHidden,
    }
  },
}
</script>
